<template>
  <div class="py-1">

    <span
      :class="statusClass"
      class="inline-block px-4 py-1 font-medium rounded-full"
      v-html="displayText"
    ></span>

    <div
      v-if="status === 'NotAgreed' && item.isReceiverRegistered"
      class="mt-1 text-gray-500"
      v-html="$tk('Common.OrderStatus.RecipientRegistered')"
    ></div>

  </div>
</template>

<script>

import { getStatusText } from "@/utilities/helpers"

export default {

  props: ["item"],

  computed: {

    status () {
      return this.item.transactionStatus
    },

    statusClass () {
      return this.status === "Web"           ? "bg-blue-500 text-blue-100" :
             this.status === "Ordered"       ? "xbg-blue-200 text-blue-500" :
             this.status === "Sent"          ? "xbg-green-200 text-green-600" :
             this.status === "NotAgreed"     ? "bg-red-500 text-red-100" :
             this.status === "Confirmed"     ? "xbg-gray-200 text-gray-500" :
             this.status === "Returnable"    ? "xbg-yellow-200 text-yellow-700" :
                                               "xbg-gray-200 text-gray-500"
    },

    displayText () {
      return getStatusText(this.status, this)
    }
  }
}
</script>